var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"800px"},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}},[_c('v-card',[_c('v-container',{staticClass:"pb-6 px-6"},[_c('v-row',[_c('service-contract',{attrs:{"typeofPlan":_vm.classificationPlan}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }